import React, { useState } from 'react';
import { Dropdown, Grid } from 'semantic-ui-react';

import {
  SelectWrapper,
  ButtonsWrapper,
  DateFieldPrefix,
  DateFieldsWrapper,
  ReportSectionWrapper
} from '../../styles';
import Button from '../../../../components/Button';
import { FieldLabel } from '../../../../styles';
import { iRootDispatch, iRootState } from '../../../../store';
import { connect } from 'react-redux';
import { Props } from './types';
import axiosInstance from '../../../../services/axios-instance';
import {
  dangerNotification,
  successNotification
} from '../../../../services/notification';
import * as Storage from '../../../../services/storage';
import CustomDatePicker from '../../../../components/CustomDatePicker';
import AppMaskedInput from '../../../../components/MaskedInput';
import { DateToStringDate } from '../../../../services/date';
import { dateFromString } from '../../helpers';
import { AvailableBrokersAndEstatesState } from '../../../../store/types/temp-types';

const dateMaskInput = (
  <AppMaskedInput
    mask={[
      /[0-9]/,
      /[0-9]/,
      '/',
      /[0-9]/,
      /[0-9]/,
      '/',
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/
    ]}
  />
);

const FireInsuranceBillingDataReport: React.FC<Props> = ({
  closeSection,
  insurers,
  availableBrokersAndEstates
}) => {
  const [selectedInsurersValues, setSelectedInsurersValues] = useState<string[]>([]);
  const [selectedEstatesValues, setSelectedEstatesValues] = useState<string[]>([]);
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  const [isExportLoading, setIsExportLoading] = useState(false);

  const insurersOptions =
    insurers
      ?.filter(insurer => insurer.value?.availability?.includes('FIRE_INSURANCE'))
      ?.map(option => ({ ...option, value: option.value?.id })) || [];

  const estateOptions =
    availableBrokersAndEstates.estates?.map(option => ({
      text: option.text,
      value: option.value.id as string
    })) || [];

  const onExportButtonClick = async () => {
    setIsExportLoading(true);

    let formattedStart = '';
    let formattedEnd = '';

    if (start) {
      const [day, month, year] = start.split('/');

      formattedStart = `${year}-${month}-${day}`;
    }

    if (end) {
      const [day, month, year] = end.split('/');

      formattedEnd = `${year}-${month}-${day}`;
    }

    try {
      const response = await axiosInstance.get('/fire-insurance/export/xlsx', {
        headers: {
          'X-External-Login': Storage.get('external_login')
        },
        params: {
          isRv: true,
          start: formattedStart || undefined,
          end: formattedEnd || undefined,
          estateId: selectedEstatesValues,
          insurerId: selectedInsurersValues
        },
        responseType: 'blob'
      });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Relatório de dados do faturamento.xlsx';

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url);

      setIsExportLoading(false);

      successNotification(
        'Sucesso!',
        'O relatório de dados do faturamento foi exportado!'
      );
    } catch (error) {
      setIsExportLoading(false);

      dangerNotification(
        'Oops...',
        'Não foi possível exportar o relatório de dados do faturamento, tente novamente mais tarde.'
      );
    }
  };

  const formattedStart = dateFromString(start);
  const formattedEnd = dateFromString(end);

  return (
    <ReportSectionWrapper>
      <Grid>
        <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
          <Grid.Column width={8}>
            <FieldLabel paddingBottom>Imobiliária(s)</FieldLabel>

            <SelectWrapper style={{ marginBottom: 0 }}>
              <Dropdown
                id="realEstatesSelect"
                placeholder="Todas imobiliárias"
                value={selectedEstatesValues}
                options={estateOptions || []}
                onChange={(_, data) => setSelectedEstatesValues(data.value as string[])}
                style={{ marginBottom: '5px' }}
                menu={{ style: { maxHeight: '300px', overflowY: 'auto' } }}
                noResultsMessage={'Carregando...'}
                clearable
                fluid
                multiple
                search
                selection
              />
            </SelectWrapper>
          </Grid.Column>

          <Grid.Column width={8}>
            <FieldLabel paddingBottom>Seguradora(s)</FieldLabel>

            <SelectWrapper style={{ marginBottom: 0 }}>
              <Dropdown
                id="insurersSelect"
                placeholder="Todas seguradoras"
                value={selectedInsurersValues}
                options={insurersOptions}
                onChange={(_, data) => setSelectedInsurersValues(data.value as string[])}
                style={{ marginBottom: '5px' }}
                menu={{ style: { maxHeight: '300px', overflowY: 'auto' } }}
                noResultsMessage="Não há opções"
                clearable
                fluid
                multiple
                search
                selection
              />
            </SelectWrapper>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={{ paddingTop: '0', paddingBottom: '0' }}>
          <Grid.Column width={12}>
            <FieldLabel>Período:</FieldLabel>

            <DateFieldsWrapper>
              <div>
                <DateFieldPrefix>De</DateFieldPrefix>

                <CustomDatePicker
                  value={start}
                  onChange={(value: Date) => setStart(DateToStringDate(value))}
                  maxDate={formattedEnd || undefined}
                  customInput={dateMaskInput}
                />
              </div>

              <div>
                <DateFieldPrefix>Até</DateFieldPrefix>

                <CustomDatePicker
                  value={end}
                  onChange={(value: Date) => setEnd(DateToStringDate(value))}
                  minDate={formattedStart || undefined}
                  customInput={dateMaskInput}
                />
              </div>
            </DateFieldsWrapper>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <ButtonsWrapper>
        <Button
          type="button"
          text="Cancelar"
          disabled={isExportLoading}
          onClick={closeSection}
          light
        />

        <Button
          type="button"
          text="Baixar relatório"
          disabled={isExportLoading}
          onClick={() => onExportButtonClick()}
        />
      </ButtonsWrapper>
    </ReportSectionWrapper>
  );
};

const mapStateToProps = (state: iRootState) => ({
  insurers: state.availableBrokersAndEstates.insurers,
  user: state.user,
  availableBrokersAndEstates: state.availableBrokersAndEstates
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

export default connect(mapStateToProps, mapDispatch)(FireInsuranceBillingDataReport);
